import type { PhotoResponse } from "@egalregal/shared";
import { requests } from "../../shared/api";

/** Square thumbnail used in the gallery grid. */
export function photoThumbnail(photo: PhotoResponse): string {
  if (photo.itemId && photo.photoId) {
    return `/api/items/${photo.itemId}/photos/${photo.photoId}/preview`;
  }
  if (photo.containerId && photo.file) {
    return requests.media.previewUrl(photo.containerId, photo.file.id);
  }
  return "";
}

/** Full original for the lightbox (originals load lazily, ticket 21). */
export function photoFull(photo: PhotoResponse): string {
  if (photo.itemId && photo.photoId) {
    return `/api/items/${photo.itemId}/photos/${photo.photoId}`;
  }
  if (photo.containerId && photo.file) {
    return requests.media.fileUrl(photo.containerId, photo.file.id);
  }
  return "";
}

/**
 * Stable identity across fetches for React keys and index lookups.
 *
 * The photo/file UUID is a content hash, so two items or containers can hold
 * byte-identical photos with the same id. Keying only on that id made React
 * see duplicate children (duplicated gallery tiles, ticket 14 e2e), so the
 * owning item/container id is part of the identity.
 */
export function photoKey(photo: PhotoResponse): string {
  if (photo.itemId && photo.photoId) return `item-${photo.itemId}-${photo.photoId}`;
  if (photo.containerId && photo.file) return `container-${photo.containerId}-${photo.file.id}`;
  if (photo.file) return `container-${photo.file.id}`;
  return "unknown";
}